<template>
  <div class="pc-dialog-wrap">
    <modal name="editPromoCode" @before-close="onClose" class="pc-modal" :adaptive="true" :scrollable="true" height="auto" width="90%" :maxWidth="560">
      <div class="pc-dialog">
        <div class="pc-dialog-header">
          <div class="pc-dialog-header-left">
            <span class="pc-dialog-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20.59 13.41l-7.18 7.18a2 2 0 0 1-2.82 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
                <line x1="7" y1="7" x2="7.01" y2="7"/>
              </svg>
            </span>
            <div>
              <h2 class="pc-dialog-title">Edit Promo Code</h2>
              <p class="pc-dialog-sub">Adjust usage limits, expiration and tag routing</p>
            </div>
          </div>
          <button class="pc-close-btn" @click="$modal.hide('editPromoCode')" title="Close">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        <div class="pc-dialog-body">
          <div class="pc-field">
            <label class="pc-label">Promo Code</label>
            <input class="pc-input" v-model="promoCodeData.code">
          </div>
          <div class="pc-field-grid">
            <div class="pc-field">
              <label class="pc-label">Total Times Used</label>
              <input class="pc-input" v-model="promoCodeData.totalTimesUsed">
            </div>
            <div class="pc-field">
              <label class="pc-label">Usage Limit</label>
              <input class="pc-input" v-model="promoCodeData.usageLimit">
            </div>
          </div>
          <div class="pc-field">
            <label class="pc-label">Expiration Date</label>
            <date-time-field class="pc-date-field" v-if="show" v-model="promoCodeData.expirationDate" name="expirationDate"
              data-vv-value-path="startDate.time" data-vv-name="expirationDate"></date-time-field>
          </div>

          <div class="pc-field pc-tag-field">
            <label class="pc-label">Tag</label>
            <selectize v-bind:options="tagsOptions" v-model="selectedTags"
              multiple size="1" data-dropdown-parent="body" data-max-options="100"
              :isRunnerTag='false' :isRaceTag='false'
              :isPromoTag='true' :promoCodeId="promoCodeData.id" :showMe='show'
              data-value-field= 'id' data-label-field='name' data-search-field= 'name' data-sort-field= 'name'
              class="pc-selectize-hidden">
            </selectize>
          </div>
        </div>

        <div class="pc-dialog-footer">
          <button class="pc-cancel-btn" @click="$modal.hide('editPromoCode')">Cancel</button>
          <button class="pc-save-btn" v-on:click="Save()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
              <polyline points="17 21 17 13 7 13 7 21"/>
              <polyline points="7 3 7 8 15 8"/>
            </svg>
            Save
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue"
import DateTimeField from '@/components/Forms/DateTimeField'
import PromoCodeService from "../../../../services/promoCode"
import moment from 'moment'
import Selectize from '@/components/Selectize'
import TagService from '../../../../services/tag'

export default {
  name: "edit-promo-code",
  data: () => ({
   promoCodeData:{},
    tagsOptions:[],
    selectedTags:[],
  }),
  props: {
    promoData: {},
    show: false
  },
  methods: {
    onClose() {
      // this.gift = ""
      this.$emit("closed", true)
    },
    openEditModal() {
      //this.promoCodeData = this.promoData.rowData     

      var data= this.promoData.rowData 
      //var that = this
      // TagService.getAllTags().then((response)=>{
      //   that.tagsOptions = response.data    
      //   that.selectedTags = data.tags.map(a => a.id)   
      // })        
      
      if(data.expirationDate && data.expirationDate!=null){
        var stillUtc = moment.utc(data.expirationDate).toDate()
        var local = moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss')
        data.expirationDate = local
      }
      if(data.tags){
        this.selectedTags = data.tags.map(a => a.id) 
      }  
      this.promoCodeData = data
      //console.log("this.promoCodeData--",this.promoCodeData)
      this.$modal.show('editPromoCode')
    },
    Save() {
      var tagList =[]
      this.selectedTags.forEach(tag => {
        tagList.push(this.tagsOptions.find((e)=>e.id == parseInt(tag)))
      })
      if(tagList.length>0){
        this.promoCodeData.tags= tagList
      }
      //console.log("his.promoCodeData-",this.promoCodeData)

      PromoCodeService.updatePromoCode(this.promoCodeData).then(response => {
        this.$emit('saved', response.data)
        this.$modal.hide('editPromoCode')
      }).catch(error => {
          console.log("err---",error) 
          this.$modal.hide('editPromoCode')
      })          
    },
    getAllTags(){
      TagService.getAllTags().then((response)=>{
        //console.log("Tags----",response)
        this.tagsOptions = response.data    
      })
    },
  },
  created() {
    this.getAllTags()
   // this.$watch("show", function(val) {})
  },

  watch: {
    show(oldVal, newVal) {
      if (this.show) {
        this.openEditModal()
      }
    }
  },
  components: {
    DateTimeField,
    Selectize
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// EditPromoCode.vue?5aaa40e4